//estimates how long it will take for the interviewer to say something
function calculateSpeechDuration(text) {
  const wordsPerMinute = 150;
  const words = text.split(/\s+/).length;
  const durationInMilliseconds = (words / wordsPerMinute) * 60 * 1000;
  return durationInMilliseconds;
}

export {calculateSpeechDuration};